import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { useDispatch, useSelector } from "react-redux";
import PostedJobView from '../../Vendor/PostedJobView';
import HoldJob from '../../Vendor/HoldJob';
import ExpiredJobsList from '../../Vendor/ExpiredJobsList';
import ArchiveJobsList from '../../Vendor/ArchiveJobsList';
import AppliedJobsVendor from '../../Vendor/AppliedJobsVendor';
import { VendorProfileProgress } from '../../../Redux/action/VendorProfileProgress';
import PostLaterJobs from '../../Vendor/PostLaterJobs';

const VendorJobs = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    // const { search } = useLocation();

    const QueryParams = new URLSearchParams(location?.search);
    const vId = QueryParams?.get('vendorId');
    // console.log("++++",vId);

    const currentTab = QueryParams?.get('active');

    // const currentTab=search.split("=")[1]
    const [activeTab, setActiveTab] = useState(currentTab ?? "posted");

    // const [activeTab, setActiveTab] = useState(currentTab??"posted");
    // console.log("Tab==================",search.split("=")[1]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    useEffect(() => {
        dispatch(VendorProfileProgress(vId));
        window.scrollTo(0, 0)
    }, []);


    return (
        <div>
            <div className="">
                {
                    !location.pathname.includes('/admin/job/vendor_jobs') &&
                    <div className="searchCanHead"></div>
                }
                {/* <div className=''>
                    <div
                        className="d-flex justify-content-around align-items-center g-xl-5 "
                        role="button"
                        style={{
                            textAlign: "center",
                            padding: "20px",
                            marginTop: "0px",
                            gap: "390px"
                        }}
                    >
                        <Link to="/vendor_dashboard"><h2 className="d-flex align-items-center gap-1 " style={{
                            padding: "5px",
                        }}  ><BiArrowBack /></h2></Link>
                        <h2 style={{ marginRight: '50px' }}>
                            <b>Manage Jobs</b>
                        </h2>
                        <h1>{" "}</h1>
                    </div>
                </div> */}
                {/* <div className='searchCanFilter' style={{ width: "90%", display: "flex", justifyContent: "space-between", margin: "0 auto", background: "#f6f6f6", marginTop: "50px" }}>
                    <div className="form-outline">
                        <input
                            type="search"
                            id="form1"
                            className="form-control-Job"
                            placeholder="Search"
                            aria-label="Search"
                        />
                    </div>
                    <div style={{
                        marginTop: "9px"
                    }}>
                        <Link to="/create_job" className="pdtn">
                            <button type="button" className="Job_btn">
                                Create New Job
                            </button>
                        </Link>
                    </div>
                </div> */}

                <div className='common_wrapper mb-4 d-flex justify-content-between align-items-center' style={{ fontSize: '14px', width: '95%', marginTop: '16px' }}>
                    <ul className="nav nav-pills justify-content-start">
                        <li className="nav-item">
                            <Link to={`/admin/job/vendor_jobs?active=posted&vendorId=${vId}`}><button className={`nav-link ${activeTab === "posted" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("posted")}>Posted Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={location.pathname.includes('admin') ? `/admin/posted_jobs?active=post-later&vendorId=${vId}` : `/posted_jobs?active=post-later`}><button className={`nav-link ${activeTab === "post-later" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("post-later")}>Post later Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={`/admin/job/vendor_jobs?active=drafted&vendorId=${vId}`}><button className={`nav-link  ${activeTab === "drafted" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("drafted")}>Drafted Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={`/admin/job/vendor_jobs?active=expired&vendorId=${vId}`}><button className={`nav-link  ${activeTab === "expired" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("expired")}>Expired Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={`/admin/job/vendor_jobs?active=archive&vendorId=${vId}`}><button className={`nav-link  ${activeTab === "archive" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("archive")}>Archived Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={`/admin/job/vendor_jobs?active=applied&vendorId=${vId}`}><button className={`nav-link  ${activeTab === "applied" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("applied")}>Applied Jobs</button></Link>
                        </li>
                    </ul>

                    {/* <Link to="/create_job" className="pdtn">
                            <button type="button" className="common_btn me-3">
                                Create New Job
                            </button>
                        </Link> */}
                </div>
                <div style={{ width: '95%' }} className='common_wrapper'>
                    {activeTab === "posted" && <PostedJobView posted="POSTED" />}
                    {activeTab === "post-later" && <PostLaterJobs posted="POSTLATER" />}
                    {activeTab === "drafted" && <HoldJob posted="ONHOLD" activeTab={activeTab} setActiveTab={setActiveTab} />}
                    {activeTab === "expired" && <ExpiredJobsList posted="EXPIRED" />}
                    {activeTab === "archive" && <ArchiveJobsList posted="" />}
                    {activeTab === "applied" && <AppliedJobsVendor posted="" />}
                </div>

            </div>
        </div >
    )
}

export default VendorJobs;
